<template>
  <div class="air-quality">
    <ComBox>
      <template #title>
        <TitleBar :title="`空气质量总览${dataTime}`">
          <template #icon>
            <img
              src="@/assets/dataScreen/icon-eyes.png"
              style="width: 33px; height: 26px; margin-right: 4px"
            />
          </template>
          <template #right>
            <TabBar :list="tabList" v-model="currentTab" @change="getData" />
          </template>
        </TitleBar>
      </template>
      <div class="content-wrapper">
        <div style="width: 100%">
          <div class="air-info">
            <img :src="formatAirList[0].img" class="pollution-info" />
            <div class="info-item">
              <img src="@/assets/dataScreen/icon-chart.png" />
              <div>
                <div class="value">{{ complexIndex }}</div>
                <div class="label">综合指数</div>
              </div>
            </div>
            <div class="info-item">
              <img src="@/assets/dataScreen/icon-pollution.png" />
              <div>
                <div class="value">{{ primaryPollutant }}</div>
                <div class="label">首要污染物</div>
              </div>
            </div>
          </div>
          <div class="air-list">
            <div
              v-for="(item, index) in formatAirList"
              :key="item.label"
              class="air-item"
              :class="index === 0 ? 'air-aqi' : 'air-other'"
              :style="
                index === 0 ? item.color && `border-color: ${item.color};` : ''
              "
            >
              <div
                class="label"
                :style="
                  index === 0 ? item.color && `background: ${item.color};` : ``
                "
              >
                {{ item.label }}
              </div>
              <div
                class="value"
                :style="
                  index === 0
                    ? item.color && `color: ${item.color};`
                    : item.color && `background: ${item.color};`
                "
              >
                {{ item.value }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ComBox>
  </div>
</template>

<script>
  import dayjs from "dayjs";
  import TitleBar from "../../common/TitleBar.vue";
  import ComBox from "../../common/ComBox.vue";
  import TabBar from "../../common/TabBar.vue";
  import { pollutionTypeLevel, formatValue } from "@/utils/pollutionLevel";
  import { getAirData } from "@/api/air";
  export default {
    name: "AirQuality",
    components: { TitleBar, ComBox, TabBar },
    data() {
      return {
        currentTab: "师范学院",
        tabList: [
          { label: "师范学院", value: "师范学院" },
          { label: "廊坊十中", value: "廊坊十中" },
        ],
        dataTime: "",
        complexIndex: "--",
        primaryPollutant: "--",
        airList: [
          { label: "AQI", key: "aqi", value: "-" },
          { label: "PM2.5", key: "pm25", value: "-" },
          { label: "PM10", key: "pm10", value: "-" },
          { label: "SO2", key: "so2", value: "-" },
          { label: "NO2", key: "no2", value: "-" },
          { label: "CO", key: "co", value: "-" },
          { label: "O3", key: "o3", value: "-" },
        ],
      };
    },
    computed: {
      formatAirList({ airList }) {
        return airList.map((item) => {
          const pollutionData =
            pollutionTypeLevel(item.label, item.value) || {};
          return {
            ...item,
            color: pollutionData.color,
            img: pollutionData.img,
          };
        });
      },
    },
    created() {
      this.getData();
    },
    mounted() {},
    methods: {
      getData() {
        getAirData({ time_type: 2, site: this.currentTab }).then((res) => {
          const { etime, data } = res.data[0] || {};
          if (!etime || !data) return;
          const updateTime = dayjs(etime * 1000)?.format("H");
          this.dataTime = updateTime ? `（${updateTime}时）` : "";
          this.airList = this.airList.map((item) => {
            return {
              ...item,
              value: formatValue(data[item.key]),
            };
          });
          this.complexIndex = formatValue(data.complex_index);
          this.primaryPollutant = formatValue(data.primary_pollutant);
        });
      }
    },
  };
</script>

<style scoped lang="less">
  .air-quality {
    width: 100%;
    height: auto;
    flex: 3;

    .content-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }

    .air-info {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      align-items: center;
      grid-gap: 8px;

      .pollution-info {
        width: 100%;
        height: 86px;
      }

      .info-item {
        display: flex;
        align-items: center;
        height: 80px;
        background: url("~@/assets/dataScreen/info-bg.png") no-repeat center/
          100% 100%;
        white-space: nowrap;

        & > img {
          width: 47px;
          height: 47px;
          margin: 0 8px;
          color: #ffffff;
        }
        .value {
          font-size: 30px;
          font-weight: bold;
          font-style: italic;
          text-indent: -2px;
        }

        .label {
          font-size: 12px;
        }
      }
    }

    .air-list {
      display: flex;
      align-items: center;
      margin: 10px 5px 0;

      .air-item {
        flex: 1;
        color: #ffffff;
        text-align: center;
        border: 1px solid;
        border-color: rgba(16, 78, 136, 0.8);
        &:nth-child(2) {
          border-left-width: 1px;
        }
        .label {
          height: 22px;
          line-height: 22px;
          font-size: 12px;
        }
        .value {
          height: 25px;
          line-height: 25px;
          font-size: 18px;
          font-weight: bold;
          font-style: italic;
        }
      }

      .air-aqi {
        margin-right: 6px;
        .value {
          background: rgba(16, 78, 136, 0.1);
        }
      }

      .air-other {
        border-left-width: 0px;
        border-right-width: 0px;
        &:last-child {
          border-right-width: 1px;
          .label {
            border-right-width: 0px;
          }
        }
        .label {
          background: rgba(16, 78, 136, 0.2);
          border-right: 0.5px solid rgba(16, 78, 136, 0.4);
        }
      }
    }
  }
</style>
